import { rebuildScenePbrPipelines } from './scene-rebuild.js';
import { StandardToneMapping } from '../material/pbr/tone-mapping.js';

async function setSceneImageProcessing(scene, update) {
  const ip = scene.imageProcessing;
  const prevEnabled = ip.toneMappingEnabled;
  const prevToneMappingId = ip.toneMapping?.id ?? StandardToneMapping.id;
  Object.assign(ip, update);
  const enabledChanged = ip.toneMappingEnabled !== prevEnabled;
  const nextToneMappingId = ip.toneMapping?.id ?? StandardToneMapping.id;
  const toneMappingChanged = ip.toneMappingEnabled && nextToneMappingId !== prevToneMappingId;
  if (enabledChanged || toneMappingChanged) {
    await rebuildScenePbrPipelines(scene);
  }
}

export { setSceneImageProcessing };
//# sourceMappingURL=scene-image-processing.js.map
